export default {"src":"https://webcdn.trailways.com/_next/static/media/chevron-dark-down-faq.8939e759.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};